// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuLinkedTableView-header{padding-right:var(--salt-spacing-100);flex:0 0 28px;align-items:center;display:flex}.vuuLinkedTableView-header .vuuTabstrip{width:fit-content}.vuuLinkedTableView-header .vuuLinkedTableView-toolTray{margin-left:auto}.vuuLinkedTableView-view{padding:var(--salt-spacing-100);overflow:hidden}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
